import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['price', 'familySelect', 'submit']
  static values = {
    url: String,
    submitWithBoost: String,
    submitWithoutBoost: String,
  }

  connect() {
    const familyId = this.familySelectTarget.value
    if (familyId) this.fetchPrices(familyId)
  }

  update({ target: { value: familyId } }) {
    if (!familyId) return

    this.fetchPrices(familyId)
  }

  updateSubmitLabel({ target }) {
    if (target.name !== 'equipment[boost_attributes][boost_type]') return

    this.submitTarget.textContent = target.value ? this.submitWithBoostValue : this.submitWithoutBoostValue
  }

  async fetchPrices(familyId) {
    const response = await fetch(`${this.urlValue}?family_id=${familyId}`)
    const prices = await response.json()

    this.priceTargets.forEach((el) => {
      el.textContent = prices[el.dataset.boostType]
    })
  }
}
